import { render, staticRenderFns } from "./chujuMain.vue?vue&type=template&id=796a404f"
import script from "./chujuMain.vue?vue&type=script&lang=js"
export * from "./chujuMain.vue?vue&type=script&lang=js"
import style0 from "./chujuMain.vue?vue&type=style&index=0&id=796a404f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports